/* site/prototypeRoutes.js — GENERATED. Every page of the lhc-site prototype mapped to its
 * platform route, so no prototype "*.html" href can ever survive into the running site.
 *
 * Regenerate after changing lhc-site/:
 *   python <scratchpad>/extract_catalog.py     (prints "routed: N / N prototype files")
 *
 * The map is derived from the prototype itself: each listing page's item array tells us which
 * detail pages belong to which world + category, which is where the /<world>/<category>/<slug>
 * shape comes from. 129/129 files are covered — including six bed/night-complement pages that
 * nothing in the prototype links to (adele, dacota, diana, hunter, parker, perno), which are
 * placed by their own breadcrumbs. */
const PROTOTYPE_ROUTES = {
  "about.html": "/about",
  "adele.html": "/systems/beds/adele",
  "arco.html": "/systems/side-boards/arco",
  "aria.html": "/kitchens/aria",
  "armchairs-bardo.html": "/indoor/armchairs/bardo",
  "armchairs-elas.html": "/indoor/armchairs/elas",
  "armchairs-elyne.html": "/indoor/armchairs/elyne",
  "armchairs-lilliam.html": "/indoor/armchairs/lilliam",
  "armchairs.html": "/indoor/armchairs",
  "atelier.html": "/systems/wardrobes/atelier",
  "basso.html": "/systems/side-boards/basso",
  "beds.html": "/systems/beds",
  "chaise-lounge-lido.html": "/indoor/chaise-lounge/lido",
  "chaise-lounge-saki.html": "/indoor/chaise-lounge/saki",
  "chaise-lounge-supermoon.html": "/indoor/chaise-lounge/supermoon",
  "chaise-lounge-twiggy.html": "/indoor/chaise-lounge/twiggy",
  "chaise-lounge.html": "/indoor/chaise-lounge",
  "coffee-tables-bezier.html": "/indoor/coffee-tables/bezier",
  "coffee-tables-blaine.html": "/indoor/coffee-tables/blaine",
  "coffee-tables-brutalist.html": "/indoor/coffee-tables/brutalist",
  "coffee-tables-cala.html": "/indoor/coffee-tables/cala",
  "coffee-tables.html": "/indoor/coffee-tables",
  "collections.html": "/collections",
  "concept-one.html": "/kitchens/concept-one",
  "contact.html": "/contact",
  "contract.html": "/contract",
  "cortina.html": "/systems/day-systems/cortina",
  "dacota.html": "/systems/beds/dacota",
  "day-systems.html": "/systems/day-systems",
  "diana.html": "/systems/beds/diana",
  "dining-chairs-elyne-chair.html": "/indoor/dining-chairs/elyne-chair",
  "dining-chairs-elza.html": "/indoor/dining-chairs/elza",
  "dining-chairs-marlow-chair.html": "/indoor/dining-chairs/marlow-chair",
  "dining-chairs-wren.html": "/indoor/dining-chairs/wren",
  "dining-chairs.html": "/indoor/dining-chairs",
  "dining-tables-bezier-dining.html": "/indoor/dining-tables/bezier-dining",
  "dining-tables-libra.html": "/indoor/dining-tables/libra",
  "dining-tables-linha.html": "/indoor/dining-tables/linha",
  "dining-tables-saki-table.html": "/indoor/dining-tables/saki-table",
  "dining-tables.html": "/indoor/dining-tables",
  "frame-slim.html": "/kitchens/frame-slim",
  "frame.html": "/kitchens/frame",
  "galleria.html": "/systems/walk-in-closets/galleria",
  "horizon.html": "/kitchens/horizon",
  "hunter.html": "/systems/beds/hunter",
  "index.html": "/",
  "indoor.html": "/indoor",
  "insula.html": "/systems/walk-in-closets/insula",
  "kitchen-detail.html": "/kitchens",
  "kitchens.html": "/kitchens",
  "landing-page.html": "/",
  "legal.html": "/legal",
  "lento.html": "/systems/side-boards/lento",
  "lhc-landing-page.html": "/",
  "linea.html": "/systems/wardrobes/linea",
  "login.html": "/partners/login",
  "lume.html": "/systems/night-complements/lume",
  "material-detail.html": "/materials",
  "materials.html": "/materials",
  "mont.html": "/kitchens/mont",
  "muro.html": "/systems/wardrobes/muro",
  "night-complements.html": "/systems/night-complements",
  "onda.html": "/systems/wardrobes/onda",
  "open.html": "/kitchens/open",
  "orla.html": "/systems/night-complements/orla",
  "outdoor-armchairs-bardo.html": "/outdoor/armchairs/bardo",
  "outdoor-armchairs-elas.html": "/outdoor/armchairs/elas",
  "outdoor-armchairs-elyne.html": "/outdoor/armchairs/elyne",
  "outdoor-armchairs-lilliam.html": "/outdoor/armchairs/lilliam",
  "outdoor-armchairs.html": "/outdoor/armchairs",
  "outdoor-chaise-lounge-lido.html": "/outdoor/chaise-lounge/lido",
  "outdoor-chaise-lounge-saki.html": "/outdoor/chaise-lounge/saki",
  "outdoor-chaise-lounge-supermoon.html": "/outdoor/chaise-lounge/supermoon",
  "outdoor-chaise-lounge-twiggy.html": "/outdoor/chaise-lounge/twiggy",
  "outdoor-chaise-lounge.html": "/outdoor/chaise-lounge",
  "outdoor-coffee-tables-bezier.html": "/outdoor/coffee-tables/bezier",
  "outdoor-coffee-tables-blaine.html": "/outdoor/coffee-tables/blaine",
  "outdoor-coffee-tables-brutalist.html": "/outdoor/coffee-tables/brutalist",
  "outdoor-coffee-tables-cala.html": "/outdoor/coffee-tables/cala",
  "outdoor-coffee-tables.html": "/outdoor/coffee-tables",
  "outdoor-dining-chairs-elyne-chair.html": "/outdoor/dining-chairs/elyne-chair",
  "outdoor-dining-chairs-elza.html": "/outdoor/dining-chairs/elza",
  "outdoor-dining-chairs-marlow-chair.html": "/outdoor/dining-chairs/marlow-chair",
  "outdoor-dining-chairs-wren.html": "/outdoor/dining-chairs/wren",
  "outdoor-dining-chairs.html": "/outdoor/dining-chairs",
  "outdoor-dining-tables-bezier-dining.html": "/outdoor/dining-tables/bezier-dining",
  "outdoor-dining-tables-libra.html": "/outdoor/dining-tables/libra",
  "outdoor-dining-tables-linha.html": "/outdoor/dining-tables/linha",
  "outdoor-dining-tables-saki-table.html": "/outdoor/dining-tables/saki-table",
  "outdoor-dining-tables.html": "/outdoor/dining-tables",
  "outdoor-side-tables-nesta.html": "/outdoor/side-tables/nesta",
  "outdoor-side-tables-onda.html": "/outdoor/side-tables/onda",
  "outdoor-side-tables-perno.html": "/outdoor/side-tables/perno",
  "outdoor-side-tables-quill.html": "/outdoor/side-tables/quill",
  "outdoor-side-tables.html": "/outdoor/side-tables",
  "outdoor-sofas-cala-sofa.html": "/outdoor/sofas/cala-sofa",
  "outdoor-sofas-orion.html": "/outdoor/sofas/orion",
  "outdoor-sofas-riva.html": "/outdoor/sofas/riva",
  "outdoor-sofas-vela-sofa.html": "/outdoor/sofas/vela-sofa",
  "outdoor-sofas.html": "/outdoor/sofas",
  "outdoor.html": "/outdoor",
  "parker.html": "/systems/beds/parker",
  "perno.html": "/systems/night-complements/perno",
  "product-detail.html": "/products",
  "products.html": "/products",
  "project-detail.html": "/projects",
  "projects.html": "/projects",
  "quadra.html": "/systems/wardrobes/quadra",
  "resources.html": "/resources",
  "riga.html": "/systems/day-systems/riga",
  "sena.html": "/systems/night-complements/sena",
  "side-boards.html": "/systems/side-boards",
  "side-tables-nesta.html": "/indoor/side-tables/nesta",
  "side-tables-onda.html": "/indoor/side-tables/onda",
  "side-tables-perno.html": "/indoor/side-tables/perno",
  "side-tables-quill.html": "/indoor/side-tables/quill",
  "side-tables.html": "/indoor/side-tables",
  "sofas-ernest.html": "/indoor/sofas/ernest",
  "sofas-joan.html": "/indoor/sofas/joan",
  "sofas-marlow.html": "/indoor/sofas/marlow",
  "sofas-orion.html": "/indoor/sofas/orion",
  "sofas-owen.html": "/indoor/sofas/owen",
  "sofas-sena-sofa.html": "/indoor/sofas/sena-sofa",
  "sofas.html": "/indoor/sofas",
  "systems.html": "/systems",
  "tela.html": "/systems/night-complements/tela",
  "vela.html": "/systems/wardrobes/vela",
  "velo.html": "/systems/night-complements/velo",
  "walk-in-closets.html": "/systems/walk-in-closets",
  "wardrobes.html": "/systems/wardrobes",
};

export default PROTOTYPE_ROUTES;
